import {IAction} from 'core/store'
import * as actions from './actionTypes'

export interface IActionClearState extends IAction<typeof actions.CLEAR_STATE> {}
export const clearState = (): IActionClearState => ({
  type: actions.CLEAR_STATE,
})



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/store/enhancers/clearStateEnhance/actions.ts